import axiosInstance from "@/api/axios-instance";
import { CouponFormData } from "../schema/coupon-schema";
import { Coupon } from "@/pages/coupons/types/coupon";

export async function updateCoupon(id: string, data: Partial<CouponFormData>) {
    const response = await axiosInstance.patch<Coupon>(`/coupon/${id}`, data);
    return response.data;
  }